export const ADMIN_PORTAL_ROLES = ['admin', 'super_admin']

export const ROLE_META = {
  super_admin: {
    label: 'Super Admin',
    color: '#7c3aed',
    icon: 'shield-checkmark',
    badgeClass: 'bg-violet-50 text-violet-700',
  },
  admin: {
    label: 'Admin',
    color: '#2563eb',
    icon: 'settings',
    badgeClass: 'bg-blue-50 text-blue-700',
  },
  teacher: {
    label: 'Teacher',
    color: '#0891b2',
    icon: 'school',
    badgeClass: 'bg-cyan-50 text-cyan-700',
  },
  student: {
    label: 'Student',
    color: '#16a34a',
    icon: 'person',
    badgeClass: 'bg-green-50 text-green-700',
  },
  parent: {
    label: 'Parent',
    color: '#d97706',
    icon: 'people',
    badgeClass: 'bg-amber-50 text-amber-700',
  },
}

export const getRoleMeta = (role) => (
  ROLE_META[role] || {
    label: role ? role.charAt(0).toUpperCase() + role.slice(1) : 'User',
    color: '#64748b',
    icon: 'person',
    badgeClass: 'bg-slate-100 text-slate-700',
  }
)

export const getRoleLabel = (role) => getRoleMeta(role).label

export const isAdminPortalRole = (role) => ADMIN_PORTAL_ROLES.includes(role)
